<template>
    <common-content-spacer height="large" class="ancillary-table">
        <common-page-header
            v-if="showHeader"
            size="medium"
            :heading="$t('pages.ancillary.ancillary_table.heading')"
        ></common-page-header>
        <div class="ancillary-table__container">
            <div v-for="(value, i) in ancillaryServices" :key="i" class="ancillary-table__container--wrapper">
                <div>
                    <div class="ancillary-table__container--group">
                        <common-icon size="gigantic" :name="getAncillaryIcon(value.id)"></common-icon>
                        <p class="ancillary-table__container--group--text">{{ value.name }}</p>
                    </div>
                    <div
                        v-for="(item, index) in value.facilityServiceTypes"
                        :key="index"
                        class="ancillary-table__container--item"
                    >
                        <checkbox-input
                            :label="item.name"
                            :isDisabled="isSending"
                            :value="checked(item.id)"
                            @change="selectionChanged(item)"
                        ></checkbox-input>
                    </div>
                </div>
            </div>
        </div>
        <common-buttons>
            <common-button
                :disabled="!checkedValues.length"
                :isProcessing="isSending"
                :label="$t('common.microcopy.done')"
                type="primary"
                @click="saveChanges"
            ></common-button>
        </common-buttons>
    </common-content-spacer>
</template>

<script>
    import CheckboxInput from 'components/form-inputs/CheckboxInput'
    import cloneDeep from 'lodash.clonedeep'

    export default {
        components: {
            CheckboxInput,
        },

        props: {
            ancillaryServices: { type: Array, required: true },
            showHeader: { type: Boolean, default: true },
            prefillValues: { type: Array, default: () => [] },
        },

        data() {
            return {
                checkedValues: [],
                isSending: false,
            }
        },

        methods: {
            getAncillaryIcon(key) {
                switch (key) {
                    case 1:
                        return 'ancillary-diagnostic'
                    case 2:
                        return 'ancillary-therapeutic'
                    case 3:
                        return 'ancillary-custodial'
                }
            },

            checked(id) {
                return this.checkedValues.map((item) => item.id).includes(id)
            },

            selectionChanged(item) {
                if (this.checkedValues.map((item) => item.id).includes(item.id)) {
                    this.checkedValues.splice(this.checkedValues.map((item) => item.id).indexOf(item.id), 1)
                } else {
                    this.checkedValues.push(item)
                }
            },

            saveChanges() {
                this.isSending = true
                this.emitEvent({ name: 'ancillary-selection-save', payload: this.checkedValues })
            },
        },

        mounted() {
            this.checkedValues = cloneDeep(this.prefillValues)
        },
    }
</script>

<style lang="scss">
    @import 'styles/components/page-elements/ancillary-table/_ancillary-table';
</style>
